export default __webpack_public_path__ + "static/media/Cross.9ec9698e.svg";